import client from './client';
import { unwrapData } from './response';

export const listDiscounts = async (params = {}) => {
  const response = await client.get('/discounts/admin', { params });
  return unwrapData(response);
};

export const createDiscount = async (payload) => {
  const response = await client.post('/discounts/admin', payload);
  return unwrapData(response, null);
};

export const updateDiscount = async (id, payload) => {
  const response = await client.put(`/discounts/admin/${id}`, payload);
  return unwrapData(response, null);
};

export const deleteDiscount = async (id) => {
  const response = await client.delete(`/discounts/admin/${id}`);
  return unwrapData(response, null);
};
